import { PendingStatus, DatasetStatus } from '@components'

export function getTooltipTitle(post) {
  if (!post?.status) return '-'

  switch (post.status) {
    case DatasetStatus.COMPLETE: {
      return 'Data was sent successfully'
    }
    case PendingStatus.ERROR: {
      return `Failed to send data: ${post.error_message || 'Unknown Error'}`
    }
    case DatasetStatus.PENDING: {
      return 'Processing'
    }
    default:
      return '-'
  }
}
